export default __webpack_public_path__ + "static/media/video-share.27edea76.svg";